import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Spinner, { SpinnerColor } from '../../generic-components/Spinner';
import { VIEWS_MAP } from '../../router/constants';

export const GlobalLoader = () => {
  const [loadTimeStamp] = useState<Date>(new Date());
  const navigate = useNavigate();
  const intervalHandler = useRef<any>(null);

  const handleTimeLoop = () => {
    // @ts-ignore
    const elapsedTimeInSeconds = (new Date() - loadTimeStamp) / 1000;
    if (elapsedTimeInSeconds >= 3) {
      navigate(`/${VIEWS_MAP.DASHBOARD}`);
    }
  };

  useEffect(() => {
    intervalHandler.current = setInterval(() => handleTimeLoop, 1000);
    return () => {
      clearInterval(intervalHandler.current);
    };
  }, []);
  return (
    <div className='absolute inset-0 bg-bw00 flex items-center justify-center'>
      <Spinner spinnerColor={SpinnerColor.Blue} height='2rem' width='2rem' />
    </div>
  );
};
